import HeaderContactUs from "../../components/HeaderContactUs/HeaderContactUs";
import ContactInfo from "../../components/ContactInfo/ContactInfo";
import ContactUsForm from "../../components/ContactUsForm/ContactUsForm";
const ContactUs = () => {
  return (
    <>
      <HeaderContactUs />
      <ContactInfo />
      <ContactUsForm />
    </>
  );
};
export default ContactUs;
